function setAutoScheduling(task) {
  const gantt = window.to_use_react_gantt;

  if (task.progress === 0) {
    task.auto_scheduling = true;
  }
}

export { setAutoScheduling };
